import { Pipe, PipeTransform } from "@angular/core";

/**
 * Transforms strings in format 'HHMM' to 'HH:MM'
 * Strings with form 'HMM' will be filled with zeros
 * e.g '700' will be transformed to '07:00'
 */
@Pipe({
	name: "timeFormat"
})
export class TimeFormatPipe implements PipeTransform {
	transform(value: string): string {
		// pad the string with leading zeros
		let timeString = value.padStart(4, "0");

		// extract hours and minutes
		let hours = timeString.slice(0, -2);
		let minutes = timeString.slice(-2);

		return `${hours}:${minutes}`;
	}
}
